import { number, date, dateTime, str, bool, timeseries, relation } from '../SelectOptions';

export const PROPERTY_TYPE_URI_BASE = 'http://www.w3.org/2001/XMLSchema#';

/**
 * Constants for property type URIs used for properties.
 * These URIs are based on the W3C XML Schema datatypes.
 */
export const PROPERTY_TYPE_URIS = {
  dateTime: PROPERTY_TYPE_URI_BASE + dateTime,
  date: PROPERTY_TYPE_URI_BASE + date,
  str: PROPERTY_TYPE_URI_BASE + str,
  bool: PROPERTY_TYPE_URI_BASE + bool,
  number: PROPERTY_TYPE_URI_BASE + number,
  timeseries: PROPERTY_TYPE_URI_BASE + timeseries,
};

export const RELATION_LABEL = 'Relation';

export const propTypeOptions = [
  { value: PROPERTY_TYPE_URIS.date, label: 'Date' },
  { value: PROPERTY_TYPE_URIS.dateTime, label: 'Date/Time' },
  { value: PROPERTY_TYPE_URIS.bool, label: 'Boolean' },
  { value: PROPERTY_TYPE_URIS.number, label: 'Number' },
  { value: PROPERTY_TYPE_URIS.str, label: 'Text' },
  { value: PROPERTY_TYPE_URIS.timeseries, label: 'Timeseries' },
];

export type TPropType =
  | typeof dateTime
  | typeof date
  | typeof str
  | typeof bool
  | typeof number
  | typeof timeseries
  | typeof relation;

// I am using a set here in case we want to add more types mapped to a single propType in the future.
export const propFilterMap: { [key: string]: Set<string> } = {
  [str]: new Set([str]),
  [date]: new Set([date, dateTime]),
  [dateTime]: new Set([dateTime, date]),
  [number]: new Set([number]),
  [bool]: new Set([bool]),
  [timeseries]: new Set([timeseries]),
};
